import React from "react";
import { Box, Typography, Link, Divider, Grid, Container, Avatar } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Logo from '../../assets/images/logo-mcdc.png'; // Replace with your actual logo path
import ClemsonLogo from '../../assets/images/logo-clemson.png'; // Replace with your actual logo path


const Footer: React.FC = () => {
    const theme = useTheme();

    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: "#0f1d2e", // Darker blue color like in the image
                color: theme.palette.primary.contrastText, // White text based on theme
                padding: "40px 0", // Add spacing to top and bottom
                marginTop: "auto",
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4} alignItems="center">
                    {/*/!* Logo Section *!/*/}
                    {/*<Grid item xs={12} sm={2} sx={{ display: 'flex', justifyContent: 'center' }}>*/}
                    {/*    <Avatar*/}
                    {/*        alt="Logo"*/}
                    {/*        src={Logo} // Your logo image*/}
                    {/*        sx={{*/}
                    {/*            width: "100%",  // Fill the container*/}
                    {/*            height: "auto", // Maintain aspect ratio*/}
                    {/*            maxWidth: "150px", // Set max width to ensure it does not grow too large*/}
                    {/*            maxHeight: "150px", // Set max height if you want to control its size*/}
                    {/*            objectFit: "contain",  // Ensure it scales without distortion*/}
                    {/*            marginBottom: 2,*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*</Grid>*/}



                    {/* Left Section */}
                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                            CODHEM Project
                        </Typography>
                        <Link href="/dashboard" color="inherit" sx={{ display: "block", marginBottom: 1, fontSize: "0.875rem" }}>
                            Apps Overview
                        </Link>
                        {/*<Link href="/about" color="inherit" sx={{ display: "block", marginBottom: 1, fontSize: "0.875rem" }}>*/}
                        {/*    About*/}
                        {/*</Link>*/}
                        <Link href="/dashboard" color="inherit" sx={{ display: "block", marginBottom: 1, fontSize: "0.875rem" }}>
                            Dashboard
                        </Link>
                    </Grid>

                    {/* Center Section */}
                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                            About
                        </Typography>
                        <Link href="/about/news-updates" color="inherit" sx={{ display: "block", marginBottom: 1, fontSize: "0.875rem" }}>
                            News and Updates
                        </Link>
                        <Link href="" color="inherit" sx={{ display: "block", marginBottom: 1, fontSize: "0.875rem" }}>
                            How to Cite
                        </Link>
                        <Link href="" color="inherit" sx={{ display: "block", marginBottom: 1, fontSize: "0.875rem" }}>
                            Publications
                        </Link>
                        <Link href="/about/terms" color="inherit" sx={{ display: "block", marginBottom: 1, fontSize: "0.875rem" }}>
                            Terms of Use
                        </Link>
                        <Link href="/about/contact-us" color="inherit" sx={{ display: "block", marginBottom: 1, fontSize: "0.875rem" }}>
                            Contact Us
                        </Link>
                    </Grid>

                    {/* Right Section */}
                    {/*<Grid item xs={12} sm={3}>*/}
                    {/*    <Typography variant="h6" gutterBottom sx={{ fontWeight: "lighter", fontSize: "1rem" }}>*/}
                    {/*        Community*/}
                    {/*    </Typography>*/}
                    {/*    <Link href="/seminar" color="inherit" sx={{ display: "block", marginBottom: 1, fontSize: "0.875rem" }}>*/}
                    {/*        Seminar*/}
                    {/*    </Link>*/}
                    {/*    <Link href="/documentation" color="inherit" sx={{ display: "block", marginBottom: 1, fontSize: "0.875rem" }}>*/}
                    {/*        Documentation*/}
                    {/*    </Link>*/}
                    {/*    <Link href="/forum" color="inherit" sx={{ display: "block", marginBottom: 1, fontSize: "0.875rem" }}>*/}
                    {/*        Forum*/}
                    {/*    </Link>*/}
                    {/*</Grid>*/}

                    {/* Logo Section */}
                    <Grid item xs={12} sm={3} sx={{display: 'flex', justifyContent: 'flex-end', marginLeft: 'auto'}}>
                        <img
                            src={Logo} // Your logo image
                            alt="Logo"
                            style={{
                                width: "auto",  // Allow the width to auto adjust
                                height: "auto", // Maintain aspect ratio
                                maxWidth: "150px", // Set maximum width to avoid it getting too large
                                maxHeight: "150px", // Set maximum height for responsiveness
                                objectFit: "contain", // Ensure the logo scales without distortion
                                marginBottom: "16px", // Add margin for spacing
                            }}
                        />
                        <img
                            src={ClemsonLogo} // Your logo image
                            alt="ClemsonLogo"
                            style={{
                                width: "auto",  // Allow the width to auto adjust
                                height: "auto", // Maintain aspect ratio
                                maxWidth: "80px", // Set maximum width to avoid it getting too large
                                maxHeight: "80px", // Set maximum height for responsiveness
                                objectFit: "contain", // Ensure the logo scales without distortion
                                marginBottom: "16px", // Add margin for spacing
                            }}
                        />
                    </Grid>
                </Grid>
                <Divider sx={{marginTop: 4, backgroundColor: theme.palette.primary.contrastText}}/>
                <Box sx={{textAlign: "center", marginTop: 2}}>
                    <Typography variant="body2" color="inherit" sx={{fontWeight: "lighter", fontSize: "0.875rem"}}>
                        © {new Date().getFullYear()} MCDC Group Clemson. All rights reserved.
                    </Typography>
                    <Box sx={{marginTop: 1}}>
                        <Link href="/about/terms" underline="hover" color="inherit"
                              sx={{marginRight: 2, fontSize: "0.875rem"}}>
                            Privacy Policy
                        </Link>
                        <Link href="/about/terms" underline="hover" color="inherit" sx={{ fontSize: "0.875rem" }}>
                            Terms of Use
                        </Link>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
